export enum QuoteRequestPeriod {
    week = 'week',
    day = 'day',
    month = 'month',
    year = 'year',
}
